<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";

export default {
    mixins: [Api, Sabit],
    props: ["DonemId", "IcKontrolDonemId"],
    components: {
        Loader
    },
    data() {
        return {
            Page: {
                PageNumber: "1",
                PageSize: "9999",
                PageDataSize: "1",
            },
            TableData: {},
            DonemAdi: "",
            loading: true,
            uri: "data:application/vnd.ms-excel;base64,",
            template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
            base64: function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                });
            },
        };
    },
    watch: {
        DonemId() {
            this.Get();
        },
    },
    methods: {
        Get() {

            let Filter = "";
            this.ActionsFilterGet({ Service: "StrRaporlama/GetIcKontrolOrtamı", Page: this.Page, Filter: Filter }).then((res) => {
                this.TableData = res.Data;

            });
        },
        ExcelExport(table, name) {
            if (!table.nodeType) table = this.$refs.kontrolortami;
            var html = table.innerHTML
            var ctx = { worksheet: name || 'Worksheet', table: html }
            var a = document.createElement('a');
            a.href = this.uri + this.base64(this.format(this.template, ctx));
            a.download = name + '.xls';
            a.click();
        },
        groupBy: function (array, key) {
            const result = {};
            array.forEach((item) => {
                if (!result[item[key]]) {
                    result[item[key]] = [];
                }
                result[item[key]].push(item);
            });
            return result;
        },
        puantoplami(Data) {
            var toplam = 0;
            for (var SubData in Data) {
                toplam += Data[SubData].Puan

            }
            return toplam;
        },
        ortalama(Data) {
            var puantop = this.puantoplami(Data);
            var avg = 0;
            if(puantop > 0){
                avg += (puantop*50)/Data.length
            }
            return avg.toFixed(2);
        },

    },

    computed: {},
    created() {
        this.Get();
    },
};
</script>
<template>
    <Loader>
        <div>
             <!--     <div class="text-sm-end">
          <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                    ExcelExport(
                        'Kontrol Ortamı',
                        'Kontrol Ortamı',
                    )
                ">
                    <i class="mdi mdi-file-export-outline me-1"></i>
                    Excel'e Aktar
                </button>
            </div> -->
            <div ref="kontrolortami" class="table-responsive">
                <div class="table-responsive">
                    <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%">
                        <tr>
                            <td colspan="10" class="h5"
                                style="text-align: center;border-color: #0049B7; border-style: solid; font-family: Arial; display: block;">
                                Kontrol Ortamı <br>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="table-responsive" >
                                    <div>
                             
                                        <table class="table table-striped table-bordered mb-0" v-for="(Data, index) in TableData" :key="index">
                             <thead>
                                                <tr style="background-color: #0049B7;" v-if="index === 0">
                                                    <th colspan="1" class="col-md-1">Standart Kod No</th>
                                                    <th colspan="1" class="col-md-3">Kamu İç Kontrol Standardı ve Genel Şartı</th>
                                                    <th colspan="1" class="col-md-1">Mevcut Durum</th>
                                                    <th colspan="1" class="col-md-1">Eylem Kod No</th>
                                                    <th colspan="1" class="col-md-1">Öngörülen Eylem ve Eylemler</th>
                                                    <th colspan="1" class="col-md-1">Sorumlu Birim veye Çalışma Grubu Üyeleri</th>
                                                    <th colspan="1" class="col-md-1">Çıktı/Sonuç</th>
                                                    <th colspan="1" class="col-md-1">Tamamlanma Tarihi</th>
                                                    <th colspan="1" class="col-md-2">Açıklama</th>
                                                </tr>
                                            </thead>
                                            <thead  >
                                                <tr style="background-color: #00ACB7;">
                                                    <th colspan="1" class="col-md-1">{{Data.StandartGrupKod}}</th>
                                                    <th colspan="11" class="col-md-11">{{Data.Standart[0].StandartAciklama}}</th>
         
                                                </tr>
                                            </thead>
                                            <tbody v-for="(StandartData, index) in Data.Standart" :key="index">
                                                <tr v-for="(EylemData, index2) in StandartData.Eylemler" :key="index2" >
                                                    <td  v-if="index2 === 0" :rowspan="StandartData.Eylemler.length" class="col-md-1">{{StandartData.StandartKodNo}}</td>
                                                    <td  v-if="index2 === 0" :rowspan="StandartData.Eylemler.length" class="col-md-1">{{StandartData.StandartSarti}}</td>
                                                    <td  v-if="index2 === 0" :rowspan="StandartData.Eylemler.length" class="col-md-1">{{StandartData.Eylemler[0].MevcutDurum}}</td>
                                                    <td colspan="1" class="col-md-1">{{EylemData.EylemKod}}</td>
                                                    <td colspan="1" class="col-md-1">{{EylemData.Eylem}}</td>
                                                    <td colspan="1" class="col-md-1" >
                                                        <tr v-for="(BirimAd,ndex) in EylemData.BirimAdis" :key="ndex">
                                                                {{BirimAd}}
                                                        </tr>
                                                  </td>
                                                    <td colspan="1" class="col-md-1">{{EylemData.Sonuc}}</td>
                                                    <td colspan="1" class="col-md-1">{{EylemData.TamamlanmaTarihi | formatDateTable}}</td>
                                                    <td colspan="1" class="col-md-1">{{EylemData.Aciklama}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        

                                        <br /><br />
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
</Loader></template>
